import React from "react";
import { AROM_ASSESSMENT } from "../../models/Enums";

interface Props {
  phaseNo: string;
  subAssessment?: string;
}

type AssessmentDataType = {
  [key in "1" | "2" | "3"]: {
    img: JSX.Element;
    main_heading: string;
    text1: string;
    text2: string;
  };
};

const assesmentData = {
  "1": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="302"
        height="388"
        viewBox="0 0 302 388"
        fill="none"
      >
        <path
          d="M7.77226 312.88L8.74337 303.62L9.73791 303.724L9.8422 302.729L10.3381 298H15.3359H16.3359V297H26.1328V298H27.1328H38.9297H39.9297V297H49.7266V298H50.7266H62.5234H63.5234V297H73.3203V298H74.3203H86.1172H87.1172V297H96.9141V298H97.9141H109.711H110.711V297H120.508V298H121.508H133.305H134.305V297H144.102V298H145.102H156.898H157.898V297H167.695V298H168.695H180.492H181.492V297H191.289V298H192.289H204.086H205.086V297H214.883V298H215.883H227.68H228.68V297H238.477V298H239.477H251.273H252.273V297H262.07V298H263.07H274.867H275.867V297H285.664V298H286.664H291.662L292.158 302.729L292.262 303.724L293.257 303.62L294.228 312.88L293.233 312.985L293.337 313.979L294.517 325.229L294.621 326.224L295.616 326.12L296.587 335.38L295.593 335.485L295.697 336.479L296.877 347.729L296.981 348.724L297.975 348.62L298.947 357.88L297.952 357.985L298.056 358.979L299.236 370.229L299.34 371.224L300.335 371.12L301.306 380.38L300.311 380.485L300.416 381.479L300.89 386H296.192H295.192V387H285.577V386H284.577H272.962H271.962V387H262.346V386H261.346H249.731H248.731V387H239.115V386H238.115H226.5H225.5V387H215.885V386H214.885H203.269H202.269V387H192.654V386H191.654H180.038H179.038V387H169.423V386H168.423H156.808H155.808V387H146.192V386H145.192H133.577H132.577V387H122.962V386H121.962H110.346H109.346V387H99.7308V386H98.7308H87.1154H86.1154V387H76.5V386H75.5H63.8846H62.8846V387H53.2692V386H52.2692H40.6538H39.6538V387H30.0385V386H29.0385H17.4231H16.4231V387H6.80769V386H5.80769H1.11034L1.58439 381.479L1.68868 380.485L0.694132 380.38L1.66524 371.12L2.65979 371.224L2.76408 370.229L3.94377 358.979L4.04806 357.985L3.05351 357.88L4.02462 348.62L5.01916 348.724L5.12345 347.729L6.30314 336.479L6.40743 335.485L5.41288 335.38L6.38399 326.12L7.37854 326.224L7.48283 325.229L8.66252 313.979L8.7668 312.985L7.77226 312.88Z"
          fill="#FAFAFA"
          stroke="#31344E"
          stroke-width="2"
          stroke-linecap="square"
          stroke-dasharray="12 12"
        />
        <g filter="url(#filter0_d_8035_539)">
          <path
            d="M143.698 370.191V366.547H148.903V370.191H143.698Z"
            fill="#F9C18C"
          />
          <path
            d="M155.149 370.191V366.547H160.355V370.191H155.149Z"
            fill="#F9C18C"
          />
          <path
            d="M143.697 378.519C140.782 374.771 142.482 371.405 143.697 370.191H148.903C151.402 371.856 150.638 376.437 149.944 378.519H143.697Z"
            fill="#6F91AB"
            stroke="#6F91AB"
            stroke-width="1.04109"
          />
          <path
            d="M159.994 378.519C162.909 374.771 161.208 371.405 159.994 370.191H154.787C152.289 371.856 153.052 376.437 153.746 378.519H159.994Z"
            fill="#6F91AB"
            stroke="#6F91AB"
            stroke-width="1.04109"
          />
          <path
            d="M147.862 216.898V216.109H154.108V216.898C154.108 217.726 154.437 218.521 155.023 219.106L156.19 220.274H145.78L146.947 219.106C147.533 218.521 147.862 217.726 147.862 216.898Z"
            fill="#F9C18C"
          />
          <path
            d="M152.305 188.081C151.45 188.081 150.579 188.033 149.726 188.1C148.927 188.162 148.034 188.094 147.256 188.262C146.249 188.48 145.46 189.022 144.65 189.647C143.995 190.152 143.359 190.921 142.858 191.565C142.566 191.941 141.679 192.094 141.636 192.624C141.554 193.658 141.276 194.902 140.614 195.764C139.889 196.709 138.738 197.255 138.342 198.497C138.186 198.988 138.198 199.473 138.302 199.972C138.424 200.562 138.789 200.848 139.066 201.352C139.396 201.951 139.503 202.784 139.143 203.393C138.817 203.945 138.222 204.363 137.772 204.813C137.263 205.323 137.422 206.688 137.808 207.202C138.105 207.597 138.844 207.851 139.256 208.098C139.699 208.364 140.2 208.632 140.722 208.686C141.594 208.777 142.002 210.033 142.306 210.677C142.559 211.215 142.867 212.017 142.939 212.596C142.97 212.841 143.986 213.277 144.188 213.41C144.766 213.79 145.407 214.062 146.039 214.347C147.036 214.795 148.163 214.802 149.233 214.871C149.974 214.919 150.695 214.722 151.427 214.722C151.566 214.722 151.69 214.916 151.78 214.998C151.982 215.18 152.228 215.285 152.468 215.405C152.879 215.611 153.299 215.855 153.73 216.012C154.393 216.252 155.223 215.99 155.862 215.826C156.912 215.558 157.618 214.954 158.287 214.107C158.846 213.398 159.18 212.36 159.956 211.826C160.31 211.583 160.725 211.585 161.142 211.537C161.81 211.461 162.482 211.395 163.146 211.293C164.407 211.098 165.049 210.516 165.73 209.392C166.181 208.647 166.056 207.945 165.874 207.139C165.804 206.826 165.853 206.501 165.648 206.234C165.449 205.975 165.274 205.715 165.092 205.447C164.831 205.062 164.457 204.778 164.377 204.288C164.298 203.807 164.416 203.23 164.44 202.741C164.49 201.746 165.706 201.221 165.562 200.108C165.483 199.498 165.305 198.88 164.838 198.479C164.372 198.078 163.894 197.753 163.372 197.42C162.873 197.102 162.363 196.687 162.096 196.144C161.764 195.467 161.634 194.526 161.467 193.787C161.336 193.204 161.09 192.876 160.689 192.475C160.307 192.093 159.876 192.031 159.459 191.733C158.071 190.741 156.778 189.576 155.323 188.692C154.57 188.235 154.172 188 153.292 188C152.721 188 152.226 188.114 151.654 188"
            stroke="#142B49"
            stroke-width="3.12327"
            stroke-linecap="round"
          />
          <path
            d="M138.492 319.698C135.993 310.12 135.369 288.292 135.369 278.575H168.163C168.579 290.651 166.948 311.716 166.081 320.739C166.497 337.396 163.825 357.871 162.437 366.026C158.689 367.275 154.976 366.547 153.588 366.026C153.588 351.867 154.629 329.935 155.149 320.739L151.506 288.465L148.382 320.739C148.799 336.98 149.944 357.697 150.464 366.026C147.133 366.859 143.524 366.373 142.136 366.026C136.722 344.372 137.451 326.118 138.492 319.698Z"
            fill="#142B49"
            stroke="#142B49"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M128.191 279.791L123.928 280.1C120.338 287.776 120.826 290.052 121.46 289.677C121.967 289.378 123.113 288.132 123.622 287.547C123.61 289.264 123.668 292.934 123.576 293.986C125.697 294.102 127.32 292.525 129.481 290.394C129.699 286.203 128.642 281.52 128.191 279.791Z"
            fill="#F9C18C"
            stroke="#F9C18C"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M174.537 279.791L178.801 280.1C182.391 287.776 181.902 290.052 181.268 289.677C180.761 289.378 179.616 288.132 179.107 287.547C179.119 289.264 179.06 292.934 179.152 293.986C177.032 294.102 175.409 292.525 173.248 290.394C173.029 286.203 174.087 281.52 174.537 279.791Z"
            fill="#F9C18C"
            stroke="#F9C18C"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M122.875 280.657C121.352 273.954 123.822 253.47 126.413 236.569C127.863 227.113 136.212 220.274 145.779 220.274H156.19H157.745C166.904 220.274 174.875 226.571 176.119 235.646C178.361 251.999 179.353 271.098 179.094 280.657H172.848C173.264 268.58 167.816 253.415 165.04 247.342C164.623 263.583 167.295 274.931 168.684 278.575C157.44 283.572 141.095 280.657 134.328 278.575C136.41 272.328 136.236 255.15 135.889 247.342C132.141 253.589 129.816 272.155 129.122 280.657H122.875Z"
            fill="#00BBB1"
            stroke="#00BBB1"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M155.67 215.589L150.985 214.548L147.341 215.069L143.177 212.986L141.615 209.343L138.492 207.781L137.451 206.219L139.533 203.096L138.492 198.932L140.574 196.329L141.615 192.685L145.779 188.521H150.464H154.629L160.875 192.685L162.437 196.329L165.56 199.973L164.519 202.575L165.56 204.658V209.863L160.355 211.945L155.67 215.589Z"
            fill="#142B49"
            stroke="#142B49"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter1_d_8035_539)">
          <path
            d="M128.967 114.026H172.49"
            stroke="#4D5264"
            stroke-width="4.3326"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M114 180L141.768 57.3086H160.083L188.245 180M151.221 64.7922V173.895"
            stroke="#1D2D3A"
            stroke-width="4.72648"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M151.024 51.2036V63.8076"
            stroke="#465464"
            stroke-width="10.6346"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="168.964"
            width="51.2035"
            height="35.6641"
            rx="7.13283"
            transform="rotate(90 168.964 0)"
            fill="#E8E2DB"
          />
          <rect
            x="166.914"
            y="7.26025"
            width="36.6831"
            height="31.843"
            rx="1.27372"
            transform="rotate(90 166.914 7.26025)"
            fill="#82D0F3"
          />
          <path
            d="M165.641 7.26025C166.344 7.26025 166.914 7.83052 166.914 8.53397L166.914 19.8701L135.071 33.7536L135.071 8.53397C135.071 7.83052 135.642 7.26025 136.345 7.26025L165.641 7.26025Z"
            fill="#399ED5"
          />
          <circle cx="151.12" cy="47.5097" r="2.29269" fill="#FAFAFA" />
        </g>
        <defs>
          <filter
            id="filter0_d_8035_539"
            x="116.495"
            y="186.438"
            width="69.7388"
            height="200.602"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_539"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_539"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_8035_539"
            x="107.636"
            y="0"
            width="86.9727"
            height="190.364"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_539"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_539"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    main_heading: "Phase 1",
    text1: "Face camera.",
    text2: " ",
  },
  "2": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="302"
        height="388"
        viewBox="0 0 302 388"
        fill="none"
      >
        <g filter="url(#filter0_d_8035_772)">
          <path
            d="M212.851 270.508C210.653 272.701 207.085 272.701 204.888 270.508C202.69 268.315 202.69 264.753 204.888 262.56L217.791 249.699H163.876C160.764 249.699 158.251 252.208 158.251 255.314V283.386C158.251 286.491 155.737 289 152.625 289C149.514 289 147 286.491 147 283.386V255.314C147 246.015 154.559 238.471 163.876 238.471H217.791L204.888 225.593C202.69 223.4 202.69 219.838 204.888 217.645C207.085 215.452 210.653 215.452 212.851 217.645L235.352 240.102C237.549 242.295 237.549 245.857 235.352 248.05L212.851 270.508Z"
            fill="#787B91"
          />
        </g>
        <path
          d="M7.77226 312.88L8.74337 303.62L9.73791 303.724L9.8422 302.729L10.3381 298H15.3359H16.3359V297H26.1328V298H27.1328H38.9297H39.9297V297H49.7266V298H50.7266H62.5234H63.5234V297H73.3203V298H74.3203H86.1172H87.1172V297H96.9141V298H97.9141H109.711H110.711V297H120.508V298H121.508H133.305H134.305V297H144.102V298H145.102H156.898H157.898V297H167.695V298H168.695H180.492H181.492V297H191.289V298H192.289H204.086H205.086V297H214.883V298H215.883H227.68H228.68V297H238.477V298H239.477H251.273H252.273V297H262.07V298H263.07H274.867H275.867V297H285.664V298H286.664H291.662L292.158 302.729L292.262 303.724L293.257 303.62L294.228 312.88L293.233 312.985L293.337 313.979L294.517 325.229L294.621 326.224L295.616 326.12L296.587 335.38L295.593 335.485L295.697 336.479L296.877 347.729L296.981 348.724L297.975 348.62L298.947 357.88L297.952 357.985L298.056 358.979L299.236 370.229L299.34 371.224L300.335 371.12L301.306 380.38L300.311 380.485L300.416 381.479L300.89 386H296.192H295.192V387H285.577V386H284.577H272.962H271.962V387H262.346V386H261.346H249.731H248.731V387H239.115V386H238.115H226.5H225.5V387H215.885V386H214.885H203.269H202.269V387H192.654V386H191.654H180.038H179.038V387H169.423V386H168.423H156.808H155.808V387H146.192V386H145.192H133.577H132.577V387H122.962V386H121.962H110.346H109.346V387H99.7308V386H98.7308H87.1154H86.1154V387H76.5V386H75.5H63.8846H62.8846V387H53.2692V386H52.2692H40.6538H39.6538V387H30.0385V386H29.0385H17.4231H16.4231V387H6.80769V386H5.80769H1.11034L1.58439 381.479L1.68868 380.485L0.694132 380.38L1.66524 371.12L2.65979 371.224L2.76408 370.229L3.94377 358.979L4.04806 357.985L3.05351 357.88L4.02462 348.62L5.01916 348.724L5.12345 347.729L6.30314 336.479L6.40743 335.485L5.41288 335.38L6.38399 326.12L7.37854 326.224L7.48283 325.229L8.66252 313.979L8.7668 312.985L7.77226 312.88Z"
          fill="#FAFAFA"
          stroke="#31344E"
          stroke-width="2"
          stroke-linecap="square"
          stroke-dasharray="12 12"
        />
        <g filter="url(#filter1_d_8035_772)">
          <path
            d="M128.967 114.026H172.49"
            stroke="#4D5264"
            stroke-width="4.3326"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M114 180L141.768 57.3086H160.083L188.245 180M151.221 64.7922V173.895"
            stroke="#1D2D3A"
            stroke-width="4.72648"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M151.024 51.2031V63.8071"
            stroke="#465464"
            stroke-width="10.6346"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="168.964"
            width="51.2035"
            height="35.6641"
            rx="7.13283"
            transform="rotate(90 168.964 0)"
            fill="#E8E2DB"
          />
          <rect
            x="166.914"
            y="7.25977"
            width="36.6831"
            height="31.843"
            rx="1.27372"
            transform="rotate(90 166.914 7.25977)"
            fill="#82D0F3"
          />
          <path
            d="M165.641 7.25977C166.344 7.25977 166.914 7.83003 166.914 8.53348L166.914 19.8696L135.071 33.7531L135.071 8.53348C135.071 7.83003 135.642 7.25976 136.345 7.25976L165.641 7.25977Z"
            fill="#399ED5"
          />
          <circle cx="151.12" cy="47.5095" r="2.29269" fill="#FAFAFA" />
        </g>
        <g filter="url(#filter2_d_8035_772)">
          <path
            d="M145.799 371.576V362.127H152.548V371.576H145.799Z"
            fill="#7B3A31"
          />
          <path
            d="M150.861 214.996V213.309V212.972L147.487 210.609V212.634L150.861 214.996Z"
            fill="#060000"
          />
          <path
            d="M157.273 202.848C157.813 201.498 157.498 198.911 157.273 197.786L149.849 193.399L141.075 199.136V217.696L150.523 218.371V214.659C149.174 214.119 147.036 211.285 146.137 209.935C150.186 213.647 152.886 213.309 154.573 213.309C155.923 213.309 156.935 209.485 157.273 207.573L159.599 206.409C159.828 206.295 159.973 206.056 159.87 205.822C159.476 204.925 158.044 203.523 157.273 202.848Z"
            fill="#7B3A31"
            stroke="#7B3A31"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M139.829 213.031C142.528 213.031 144.778 210.106 145.566 208.644C145.116 208.306 144.013 207.294 143.203 205.944C142.191 204.257 143.878 200.545 145.228 200.882C146.308 201.152 146.803 203.019 146.915 203.919C147.995 203.379 148.49 200.545 148.603 199.195C149.413 198.925 150.515 196.833 150.965 195.82C155.554 199.33 158.501 198.407 159.401 197.508C155.689 194.47 158.051 193.121 153.327 189.409C149.548 186.439 146.128 188.846 144.891 190.421C143.203 189.409 139.289 188.666 137.13 193.796C134.97 198.925 137.804 204.257 139.491 206.281C138.681 208.171 139.379 211.568 139.829 213.031Z"
            fill="#060000"
          />
          <path
            d="M157.376 209.656C157.916 209.116 157.601 208.306 157.376 207.969C156.297 208.509 153.777 208.644 152.652 208.644C154.272 209.723 156.477 209.768 157.376 209.656Z"
            fill="#060000"
          />
          <path
            d="M139.829 213.031C142.528 213.031 144.778 210.106 145.566 208.644C145.116 208.306 144.013 207.294 143.203 205.944C142.191 204.257 143.878 200.545 145.228 200.882C146.308 201.152 146.803 203.019 146.915 203.919C147.995 203.379 148.49 200.545 148.603 199.195C149.413 198.925 150.515 196.833 150.965 195.82C155.554 199.33 158.501 198.407 159.401 197.508C155.689 194.47 158.051 193.121 153.327 189.409C149.548 186.439 146.128 188.846 144.891 190.421C143.203 189.409 139.289 188.666 137.13 193.796C134.97 198.925 137.804 204.257 139.491 206.281C138.681 208.171 139.379 211.568 139.829 213.031Z"
            stroke="#060000"
            stroke-width="0.674912"
            stroke-linejoin="round"
          />
          <path
            d="M157.376 209.656C157.916 209.116 157.601 208.306 157.376 207.969C156.297 208.509 153.777 208.644 152.652 208.644C154.272 209.723 156.477 209.768 157.376 209.656Z"
            stroke="#060000"
            stroke-width="0.674912"
            stroke-linejoin="round"
          />
          <path
            d="M145.461 371.576V368.201H145.124C144.006 368.201 143.099 369.108 143.099 370.226V379H166.384C165.844 373.061 158.96 370.676 155.585 370.226C155.922 369.326 155.922 367.526 153.223 367.526C150.523 367.526 149.848 370.226 149.848 371.576H145.461Z"
            fill="#5B5B5B"
            stroke="#5B5B5B"
            stroke-width="0.674912"
          />
          <path
            d="M163.347 372.25C161.772 372.475 158.42 373.33 157.61 374.95M157.947 372.25C159.297 372.363 162.267 373.06 163.347 374.95M154.573 371.913C154.91 371.463 155.99 370.496 157.61 370.226M154.573 370.226C155.135 370.226 156.597 370.496 157.947 371.575"
            stroke="black"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M156.597 316.234C159.027 310.294 160.309 288.112 160.647 277.764C156.058 273.174 145.011 277.201 140.061 279.788C139.521 288.157 142.986 306.448 144.786 314.546C139.927 327.235 142.762 351.554 144.786 362.128H153.223C153.223 335.941 155.472 320.621 156.597 316.234Z"
            fill="#060000"
            stroke="black"
            stroke-width="0.674912"
          />
          <path
            d="M146.555 280.214L151.734 279.233C155.04 283.85 155.823 286.496 155.698 287.85C155.629 288.592 154.761 288.457 154.233 287.931C153.864 287.564 153.464 287.213 153.206 287.001C153.835 289.075 153.9 291.424 153.812 293.027C153.771 293.778 153.074 294.288 152.363 294.041C150.705 293.465 148.546 292.204 147.737 289.929C146.682 286.963 146.509 282.217 146.555 280.214Z"
            fill="#7B3A31"
            stroke="#7B3A31"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M135 229.17V274.54C135 276.127 135.811 277.605 137.15 278.457C138.181 279.113 139.331 279.572 140.542 279.729C149.21 280.855 157.222 279.196 161.531 277.764C162.632 277.399 163.286 276.314 163.201 275.158C162.505 265.646 161.407 247.593 161.659 238.281C161.929 228.292 154.797 220.846 151.198 218.371L140.737 217.696C136.417 219.046 135.112 225.908 135 229.17Z"
            fill="#FFAD00"
            stroke="#FFAD00"
            stroke-width="0.674912"
          />
          <path
            d="M138.48 250.767C138.106 243.857 138.788 236.333 139.542 230.9C139.987 227.688 143.074 225.634 146.253 226.27C148.84 226.787 150.768 228.963 150.971 231.594L151.303 235.919C151.573 239.158 149.391 247.167 148.266 250.767C150.966 263.725 152.766 275.963 153.328 280.463H146.241C140.572 271.554 138.705 256.953 138.48 250.767Z"
            fill="#E69400"
            stroke="#E69400"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M138 217.607C138 216.167 139.167 215 140.607 215H152.5L155.5 221.5L140.384 220.204C139.036 220.089 138 218.96 138 217.607Z"
            fill="#E5854F"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_8035_772"
            x="143"
            y="216"
            width="98"
            height="81"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_772"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_772"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_8035_772"
            x="107.636"
            y="0"
            width="86.9727"
            height="190.364"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_772"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_772"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_8035_772"
            x="130.663"
            y="187.662"
            width="40.0906"
            height="199.675"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_772"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_772"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    main_heading: "Phase 2: Left Arm",
    text1: "Left arm should be",
    text2: "visible to the camera.",
  },
  "3": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="302"
        height="388"
        viewBox="0 0 302 388"
        fill="none"
      >
        <g filter="url(#filter0_d_8035_791)">
          <path
            d="M84.1491 270.508C86.3465 272.701 89.915 272.701 92.1124 270.508C94.3098 268.315 94.3098 264.753 92.1124 262.56L79.2094 249.699H133.124C136.236 249.699 138.749 252.208 138.749 255.314V283.386C138.749 286.491 141.263 289 144.375 289C147.486 289 150 286.491 150 283.386V255.314C150 246.015 142.441 238.471 133.124 238.471H79.2094L92.1124 225.593C94.3098 223.4 94.3098 219.838 92.1124 217.645C89.915 215.452 86.3465 215.452 84.1491 217.645L61.648 240.102C59.4507 242.295 59.4507 245.857 61.648 248.05L84.1491 270.508Z"
            fill="#787B91"
          />
        </g>
        <path
          d="M7.77226 312.88L8.74337 303.62L9.73791 303.724L9.8422 302.729L10.3381 298H15.3359H16.3359V297H26.1328V298H27.1328H38.9297H39.9297V297H49.7266V298H50.7266H62.5234H63.5234V297H73.3203V298H74.3203H86.1172H87.1172V297H96.9141V298H97.9141H109.711H110.711V297H120.508V298H121.508H133.305H134.305V297H144.102V298H145.102H156.898H157.898V297H167.695V298H168.695H180.492H181.492V297H191.289V298H192.289H204.086H205.086V297H214.883V298H215.883H227.68H228.68V297H238.477V298H239.477H251.273H252.273V297H262.07V298H263.07H274.867H275.867V297H285.664V298H286.664H291.662L292.158 302.729L292.262 303.724L293.257 303.62L294.228 312.88L293.233 312.985L293.337 313.979L294.517 325.229L294.621 326.224L295.616 326.12L296.587 335.38L295.593 335.485L295.697 336.479L296.877 347.729L296.981 348.724L297.975 348.62L298.947 357.88L297.952 357.985L298.056 358.979L299.236 370.229L299.34 371.224L300.335 371.12L301.306 380.38L300.311 380.485L300.416 381.479L300.89 386H296.192H295.192V387H285.577V386H284.577H272.962H271.962V387H262.346V386H261.346H249.731H248.731V387H239.115V386H238.115H226.5H225.5V387H215.885V386H214.885H203.269H202.269V387H192.654V386H191.654H180.038H179.038V387H169.423V386H168.423H156.808H155.808V387H146.192V386H145.192H133.577H132.577V387H122.962V386H121.962H110.346H109.346V387H99.7308V386H98.7308H87.1154H86.1154V387H76.5V386H75.5H63.8846H62.8846V387H53.2692V386H52.2692H40.6538H39.6538V387H30.0385V386H29.0385H17.4231H16.4231V387H6.80769V386H5.80769H1.11034L1.58439 381.479L1.68868 380.485L0.694132 380.38L1.66524 371.12L2.65979 371.224L2.76408 370.229L3.94377 358.979L4.04806 357.985L3.05351 357.88L4.02462 348.62L5.01916 348.724L5.12345 347.729L6.30314 336.479L6.40743 335.485L5.41288 335.38L6.38399 326.12L7.37854 326.224L7.48283 325.229L8.66252 313.979L8.7668 312.985L7.77226 312.88Z"
          fill="#FAFAFA"
          stroke="#31344E"
          stroke-width="2"
          stroke-linecap="square"
          stroke-dasharray="12 12"
        />
        <g filter="url(#filter1_d_8035_791)">
          <path
            d="M128.967 114.026H172.49"
            stroke="#4D5264"
            stroke-width="4.3326"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M114 180L141.768 57.3086H160.083L188.245 180M151.221 64.7922V173.895"
            stroke="#1D2D3A"
            stroke-width="4.72648"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M151.024 51.2031V63.8071"
            stroke="#465464"
            stroke-width="10.6346"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="168.964"
            width="51.2035"
            height="35.6641"
            rx="7.13283"
            transform="rotate(90 168.964 0)"
            fill="#E8E2DB"
          />
          <rect
            x="166.914"
            y="7.25977"
            width="36.6831"
            height="31.843"
            rx="1.27372"
            transform="rotate(90 166.914 7.25977)"
            fill="#82D0F3"
          />
          <path
            d="M165.641 7.25977C166.344 7.25977 166.914 7.83003 166.914 8.53348L166.914 19.8696L135.071 33.7531L135.071 8.53348C135.071 7.83003 135.642 7.25976 136.345 7.25976L165.641 7.25977Z"
            fill="#399ED5"
          />
          <circle cx="151.12" cy="47.5095" r="2.29269" fill="#FAFAFA" />
        </g>
        <g filter="url(#filter2_d_8035_791)">
          <path
            d="M151.201 371.576V362.127H144.452V371.576H151.201Z"
            fill="#7B3A31"
          />
          <path
            d="M146.139 214.996V213.309V212.972L149.513 210.609V212.634L146.139 214.996Z"
            fill="#060000"
          />
          <path
            d="M139.727 202.848C139.187 201.498 139.502 198.911 139.727 197.786L147.151 193.399L155.925 199.136V217.696L146.477 218.371V214.659C147.826 214.119 149.964 211.285 150.863 209.935C146.814 213.647 144.114 213.309 142.427 213.309C141.077 213.309 140.065 209.485 139.727 207.573L137.401 206.409C137.172 206.295 137.027 206.056 137.13 205.822C137.524 204.925 138.956 203.523 139.727 202.848Z"
            fill="#7B3A31"
            stroke="#7B3A31"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M157.171 213.031C154.472 213.031 152.222 210.106 151.434 208.644C151.884 208.306 152.987 207.294 153.797 205.944C154.809 204.257 153.122 200.545 151.772 200.882C150.692 201.152 150.197 203.019 150.085 203.919C149.005 203.379 148.51 200.545 148.397 199.195C147.587 198.925 146.485 196.833 146.035 195.82C141.446 199.33 138.499 198.407 137.599 197.508C141.311 194.47 138.949 193.121 143.673 189.409C147.452 186.439 150.872 188.846 152.109 190.421C153.797 189.409 157.711 188.666 159.87 193.796C162.03 198.925 159.196 204.257 157.509 206.281C158.319 208.171 157.621 211.568 157.171 213.031Z"
            fill="#060000"
          />
          <path
            d="M139.624 209.656C139.084 209.116 139.399 208.306 139.624 207.969C140.703 208.509 143.223 208.644 144.348 208.644C142.728 209.723 140.523 209.768 139.624 209.656Z"
            fill="#060000"
          />
          <path
            d="M157.171 213.031C154.472 213.031 152.222 210.106 151.434 208.644C151.884 208.306 152.987 207.294 153.797 205.944C154.809 204.257 153.122 200.545 151.772 200.882C150.692 201.152 150.197 203.019 150.085 203.919C149.005 203.379 148.51 200.545 148.397 199.195C147.587 198.925 146.485 196.833 146.035 195.82C141.446 199.33 138.499 198.407 137.599 197.508C141.311 194.47 138.949 193.121 143.673 189.409C147.452 186.439 150.872 188.846 152.109 190.421C153.797 189.409 157.711 188.666 159.87 193.796C162.03 198.925 159.196 204.257 157.509 206.281C158.319 208.171 157.621 211.568 157.171 213.031Z"
            stroke="#060000"
            stroke-width="0.674912"
            stroke-linejoin="round"
          />
          <path
            d="M139.624 209.656C139.084 209.116 139.399 208.306 139.624 207.969C140.703 208.509 143.223 208.644 144.348 208.644C142.728 209.723 140.523 209.768 139.624 209.656Z"
            stroke="#060000"
            stroke-width="0.674912"
            stroke-linejoin="round"
          />
          <path
            d="M151.539 371.576V368.201H151.876C152.994 368.201 153.901 369.108 153.901 370.226V379H130.616C131.156 373.061 138.04 370.676 141.415 370.226C141.078 369.326 141.078 367.526 143.777 367.526C146.477 367.526 147.152 370.226 147.152 371.576H151.539Z"
            fill="#5B5B5B"
            stroke="#5B5B5B"
            stroke-width="0.674912"
          />
          <path
            d="M133.653 372.25C135.228 372.475 138.58 373.33 139.39 374.95M139.053 372.25C137.703 372.363 134.733 373.06 133.653 374.95M142.427 371.913C142.09 371.463 141.01 370.496 139.39 370.226M142.427 370.226C141.865 370.226 140.403 370.496 139.053 371.575"
            stroke="black"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M140.403 316.234C137.973 310.294 136.691 288.112 136.353 277.764C140.942 273.174 151.989 277.201 156.939 279.788C157.479 288.157 154.014 306.448 152.214 314.546C157.073 327.235 154.238 351.554 152.214 362.128H143.777C143.777 335.941 141.528 320.621 140.403 316.234Z"
            fill="#060000"
            stroke="black"
            stroke-width="0.674912"
          />
          <path
            d="M150.445 280.214L145.266 279.233C141.96 283.85 141.177 286.496 141.302 287.85C141.371 288.592 142.239 288.457 142.767 287.931C143.136 287.564 143.536 287.213 143.794 287.001C143.165 289.075 143.1 291.424 143.188 293.027C143.229 293.778 143.926 294.288 144.637 294.041C146.295 293.465 148.454 292.204 149.263 289.929C150.318 286.963 150.491 282.217 150.445 280.214Z"
            fill="#7B3A31"
            stroke="#7B3A31"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M162 229.17V274.54C162 276.127 161.189 277.605 159.85 278.457C158.819 279.113 157.669 279.572 156.458 279.729C147.79 280.855 139.778 279.196 135.469 277.764C134.368 277.399 133.714 276.314 133.799 275.158C134.495 265.646 135.593 247.593 135.341 238.281C135.071 228.292 142.203 220.846 145.802 218.371L156.263 217.696C160.583 219.046 161.888 225.908 162 229.17Z"
            fill="#FFAD00"
            stroke="#FFAD00"
            stroke-width="0.674912"
          />
          <path
            d="M158.52 250.767C158.894 243.857 158.212 236.333 157.458 230.9C157.013 227.688 153.926 225.634 150.747 226.27C148.16 226.787 146.232 228.963 146.029 231.594L145.697 235.919C145.427 239.158 147.609 247.167 148.734 250.767C146.034 263.725 144.234 275.963 143.672 280.463H150.759C156.428 271.554 158.295 256.953 158.52 250.767Z"
            fill="#E69400"
            stroke="#E69400"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M159 217.607C159 216.167 157.833 215 156.393 215H144.5L141.5 221.5L156.616 220.204C157.964 220.089 159 218.96 159 217.607Z"
            fill="#E5854F"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_8035_791"
            x="56"
            y="216"
            width="98"
            height="81"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_791"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_791"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_8035_791"
            x="107.636"
            y="0"
            width="86.9727"
            height="190.364"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_791"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_791"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_8035_791"
            x="126.247"
            y="187.662"
            width="40.0906"
            height="199.675"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_8035_791"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_8035_791"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    main_heading: "Phase 3: Right Arm",
    text1: "Right arm should be",
    text2: "visible to the camera.",
  },
};

const FRAssesmentData = {
  "1": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="303"
        height="388"
        viewBox="0 0 303 388"
        fill="none"
      >
        <path
          d="M286.61 298H292.608L293.104 302.729L293.208 303.724L294.202 303.619L295.173 312.88L294.179 312.984L294.284 313.979L295.463 325.229L295.567 326.224L296.561 326.119L297.533 335.38L296.539 335.484L296.643 336.479L297.823 347.729L297.926 348.724L298.92 348.619L299.892 357.88L298.898 357.984L299.002 358.979L300.182 370.229L300.286 371.224L301.28 371.119L302.251 380.38L301.257 380.484L301.362 381.479L301.835 386H296.138V387H286.523V386H272.908V387H263.292V386H249.676V387H240.061V386H226.446V387H216.831V386H203.215V387H193.6V386H179.984V387H170.369V386H156.753V387H147.138V386H133.523V387H123.908V386H110.292V387H100.676V386H87.061V387H77.4458V386H63.8306V387H54.2153V386H40.6001V387H30.9839V386H17.3687V387H7.75342V386H2.05615L2.52979 381.479L2.63428 380.484L1.63916 380.38L2.61084 371.119L3.60596 371.224L3.70947 370.229L4.88916 358.979L4.99365 357.984L3.99854 357.88L4.97021 348.619L5.96533 348.724L6.06885 347.729L7.24854 336.479L7.35303 335.484L6.35791 335.38L7.32959 326.119L8.32471 326.224L8.42822 325.229L9.60791 313.979L9.7124 312.984L8.71729 312.88L9.68896 303.619L10.6841 303.724L10.7876 302.729L11.2837 298H17.2817V297H27.0786V298H40.8755V297H50.6724V298H64.4692V297H74.2661V298H88.063V297H97.8599V298H111.657V297H121.454V298H135.25V297H145.047V298H158.844V297H168.641V298H182.438V297H192.235V298H206.032V297H215.829V298H229.625V297H239.422V298H253.219V297H263.016V298H276.813V297H286.61V298Z"
          fill="#FAFAFA"
          stroke="#31344E"
          stroke-width="2"
          stroke-linecap="square"
          stroke-dasharray="12 12"
        />
        <g filter="url(#filter0_d_12544_9565)">
          <path
            d="M144.643 370.191V366.547H149.849V370.191H144.643Z"
            fill="#7B3A31"
          />
          <path
            d="M156.095 370.191V366.547H161.301V370.191H156.095Z"
            fill="#7B3A31"
          />
          <path
            d="M144.642 378.519C141.727 374.771 143.428 371.405 144.642 370.19H149.849C152.347 371.856 151.584 376.437 150.89 378.519H144.642Z"
            fill="#5B5B5B"
            stroke="#5B5B5B"
            stroke-width="1.04109"
          />
          <path
            d="M160.939 378.519C163.854 374.771 162.154 371.405 160.939 370.19H155.733C153.234 371.856 153.998 376.437 154.692 378.519H160.939Z"
            fill="#5B5B5B"
            stroke="#5B5B5B"
            stroke-width="1.04109"
          />
          <path
            d="M148.808 216.898V216.109H155.054V216.898C155.054 217.726 155.383 218.521 155.969 219.106L157.136 220.274H146.725L147.893 219.106C148.478 218.521 148.808 217.726 148.808 216.898Z"
            fill="#7B3A31"
          />
          <path
            d="M153.251 188.081C152.396 188.081 151.525 188.033 150.672 188.1C149.873 188.162 148.98 188.094 148.202 188.262C147.195 188.48 146.406 189.022 145.595 189.647C144.941 190.152 144.305 190.921 143.804 191.565C143.511 191.941 142.624 192.094 142.582 192.624C142.499 193.658 142.221 194.902 141.559 195.764C140.834 196.709 139.683 197.255 139.288 198.497C139.132 198.988 139.144 199.473 139.247 199.972C139.37 200.562 139.735 200.848 140.012 201.352C140.342 201.951 140.449 202.784 140.089 203.393C139.762 203.945 139.168 204.363 138.718 204.813C138.209 205.323 138.368 206.688 138.754 207.202C139.05 207.597 139.789 207.851 140.202 208.098C140.645 208.364 141.146 208.632 141.668 208.686C142.54 208.777 142.948 210.033 143.252 210.677C143.505 211.215 143.813 212.017 143.885 212.596C143.916 212.841 144.932 213.277 145.134 213.41C145.712 213.79 146.353 214.062 146.984 214.347C147.982 214.795 149.109 214.802 150.179 214.871C150.92 214.919 151.641 214.722 152.373 214.722C152.512 214.722 152.635 214.916 152.726 214.998C152.928 215.18 153.173 215.285 153.414 215.405C153.825 215.611 154.245 215.855 154.676 216.012C155.339 216.252 156.169 215.99 156.807 215.826C157.857 215.558 158.564 214.954 159.232 214.107C159.792 213.398 160.125 212.36 160.902 211.826C161.256 211.583 161.671 211.585 162.087 211.537C162.755 211.461 163.428 211.395 164.092 211.293C165.353 211.098 165.994 210.516 166.675 209.392C167.127 208.647 167.002 207.945 166.82 207.139C166.75 206.826 166.799 206.501 166.594 206.234C166.395 205.975 166.22 205.715 166.037 205.447C165.776 205.062 165.403 204.778 165.323 204.288C165.244 203.807 165.361 203.23 165.386 202.741C165.436 201.746 166.652 201.221 166.508 200.108C166.429 199.498 166.251 198.88 165.784 198.479C165.318 198.078 164.84 197.753 164.318 197.42C163.819 197.102 163.309 196.687 163.042 196.144C162.709 195.467 162.58 194.526 162.413 193.787C162.282 193.204 162.036 192.876 161.635 192.475C161.253 192.093 160.822 192.031 160.404 191.733C159.016 190.741 157.724 189.576 156.269 188.692C155.516 188.235 155.118 188 154.237 188C153.667 188 153.171 188.114 152.599 188"
            stroke="#060000"
            stroke-width="3.12327"
            stroke-linecap="round"
          />
          <path
            d="M139.437 319.698C136.939 310.12 136.314 288.292 136.314 278.575H169.109C169.525 290.652 167.894 311.717 167.026 320.739C167.443 337.397 164.771 357.871 163.383 366.027C159.635 367.276 155.921 366.547 154.533 366.027C154.533 351.868 155.574 329.936 156.095 320.739L152.451 288.466L149.328 320.739C149.744 336.98 150.889 357.698 151.41 366.027C148.079 366.86 144.469 366.374 143.081 366.027C137.668 344.372 138.396 326.118 139.437 319.698Z"
            fill="#060000"
            stroke="#060000"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M129.137 279.792L124.874 280.1C121.283 287.776 121.772 290.052 122.406 289.678C122.913 289.379 124.058 288.133 124.567 287.547C124.555 289.264 124.614 292.935 124.522 293.986C126.642 294.102 128.265 292.526 130.426 290.395C130.645 286.204 129.587 281.521 129.137 279.792Z"
            fill="#7B3A31"
            stroke="#7B3A31"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M175.483 279.792L179.746 280.1C183.337 287.776 182.848 290.052 182.214 289.678C181.707 289.379 180.562 288.133 180.052 287.547C180.065 289.264 180.006 292.935 180.098 293.986C177.978 294.102 176.355 292.526 174.194 290.395C173.975 286.204 175.033 281.521 175.483 279.792Z"
            fill="#7B3A31"
            stroke="#7B3A31"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M123.821 280.657C122.297 273.954 124.768 253.469 127.358 236.569C128.808 227.113 137.158 220.273 146.725 220.273H157.136H158.69C167.85 220.273 175.82 226.571 177.065 235.646C179.307 251.999 180.298 271.098 180.04 280.657H173.793C174.21 268.58 168.762 253.415 165.985 247.342C165.569 263.583 168.241 274.931 169.629 278.574C158.385 283.572 142.04 280.657 135.273 278.574C137.355 272.328 137.182 255.15 136.835 247.342C133.087 253.588 130.762 272.154 130.067 280.657H123.821Z"
            fill="#FFAD00"
            stroke="#FFAD00"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
          <path
            d="M156.616 215.589L151.931 214.548L148.287 215.068L144.122 212.986L142.561 209.342L139.438 207.781L138.396 206.219L140.479 203.096L139.438 198.931L141.52 196.329L142.561 192.685L146.725 188.521H151.41H155.574L161.821 192.685L163.383 196.329L166.506 199.972L165.465 202.575L166.506 204.657V209.863L161.3 211.945L156.616 215.589Z"
            fill="#060000"
            stroke="#060000"
            stroke-width="1.04109"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter1_d_12544_9565)">
          <path
            d="M129.913 114.026H173.436"
            stroke="#4D5264"
            stroke-width="4.3326"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M114.946 180L142.714 57.3086H161.029L189.191 180M152.167 64.7922V173.895"
            stroke="#1D2D3A"
            stroke-width="4.72648"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M151.97 51.2031V63.8071"
            stroke="#465464"
            stroke-width="10.6346"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="169.91"
            width="51.2035"
            height="35.6641"
            rx="7.13283"
            transform="rotate(90 169.91 0)"
            fill="#E8E2DB"
          />
          <rect
            x="167.86"
            y="7.25977"
            width="36.6831"
            height="31.843"
            rx="1.27372"
            transform="rotate(90 167.86 7.25977)"
            fill="#82D0F3"
          />
          <path
            d="M166.586 7.25977C167.29 7.25977 167.86 7.83003 167.86 8.53348L167.86 19.8696L136.017 33.7531L136.017 8.53348C136.017 7.83003 136.587 7.25976 137.291 7.25976L166.586 7.25977Z"
            fill="#399ED5"
          />
          <circle cx="152.066" cy="47.5095" r="2.29269" fill="#FAFAFA" />
        </g>
        <defs>
          <filter
            id="filter0_d_12544_9565"
            x="117.44"
            y="186.438"
            width="69.739"
            height="200.602"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12544_9565"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12544_9565"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_12544_9565"
            x="108.582"
            y="0"
            width="86.9727"
            height="190.364"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12544_9565"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12544_9565"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    main_heading: "Phase 1: Left Reach",
    text1: "Face device.",
    text2: " ",
  },
  "2": {
    img: <div></div>,
    main_heading: " ",
    text1: " ",
    text2: " ",
  },
  "3": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="302"
        height="388"
        viewBox="0 0 302 388"
        fill="none"
      >
        <g filter="url(#filter0_d_12793_7623)">
          <path
            d="M217.851 271.008C215.654 273.201 212.085 273.201 209.888 271.008C207.69 268.815 207.69 265.253 209.888 263.06L222.791 250.199H168.876C165.764 250.199 163.251 252.708 163.251 255.814V283.886C163.251 286.991 160.737 289.5 157.625 289.5C154.514 289.5 152 286.991 152 283.886V255.814C152 246.515 159.559 238.971 168.876 238.971H222.791L209.888 226.093C207.69 223.9 207.69 220.338 209.888 218.145C212.085 215.952 215.654 215.952 217.851 218.145L240.352 240.602C242.549 242.795 242.549 246.357 240.352 248.55L217.851 271.008Z"
            fill="#787B91"
          />
        </g>
        <path
          d="M16.3359 298.5H10.3379L9.8418 303.229L9.73828 304.224L8.74414 304.119L7.77246 313.38L8.7666 313.484L8.66211 314.479L7.48242 325.729L7.37891 326.724L6.38477 326.619L5.41309 335.88L6.40723 335.984L6.30273 336.979L5.12305 348.229L5.01953 349.224L4.02539 349.119L3.05371 358.38L4.04785 358.484L3.94336 359.479L2.76367 370.729L2.66016 371.724L1.66602 371.619L0.694336 380.88L1.68848 380.984L1.58398 381.979L1.11035 386.5H6.80762V387.5H16.4229V386.5H30.0381V387.5H39.6533V386.5H53.2695V387.5H62.8848V386.5H76.5V387.5H86.1152V386.5H99.7305V387.5H109.346V386.5H122.962V387.5H132.577V386.5H146.192V387.5H155.808V386.5H169.423V387.5H179.038V386.5H192.654V387.5H202.27V386.5H215.885V387.5H225.5V386.5H239.115V387.5H248.73V386.5H262.346V387.5H271.962V386.5H285.577V387.5H295.192V386.5H300.89L300.416 381.979L300.312 380.984L301.307 380.88L300.335 371.619L299.34 371.724L299.236 370.729L298.057 359.479L297.952 358.484L298.947 358.38L297.976 349.119L296.98 349.224L296.877 348.229L295.697 336.979L295.593 335.984L296.588 335.88L295.616 326.619L294.621 326.724L294.518 325.729L293.338 314.479L293.233 313.484L294.229 313.38L293.257 304.119L292.262 304.224L292.158 303.229L291.662 298.5H285.664V297.5H275.867V298.5H262.07V297.5H252.273V298.5H238.477V297.5H228.68V298.5H214.883V297.5H205.086V298.5H191.289V297.5H181.492V298.5H167.695V297.5H157.898V298.5H144.102V297.5H134.305V298.5H120.508V297.5H110.711V298.5H96.9141V297.5H87.1172V298.5H73.3203V297.5H63.5234V298.5H49.7266V297.5H39.9297V298.5H26.1328V297.5H16.3359V298.5Z"
          fill="#FAFAFA"
          stroke="#00968E"
          stroke-width="2"
          stroke-linecap="square"
          stroke-dasharray="12 12"
        />
        <g filter="url(#filter1_d_12793_7623)">
          <path
            d="M173.033 114.526H129.51"
            stroke="#4D5264"
            stroke-width="4.3326"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M188 180.5L160.232 57.8086H141.917L113.755 180.5M150.779 65.2922V174.395"
            stroke="#1D2D3A"
            stroke-width="4.72648"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M150.976 51.7031V64.3071"
            stroke="#465464"
            stroke-width="10.6346"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            width="51.2035"
            height="35.6641"
            rx="7.13283"
            transform="matrix(4.37114e-08 1 1 -4.37114e-08 133.036 0.5)"
            fill="#E8E2DB"
          />
          <rect
            width="36.6831"
            height="31.843"
            rx="1.27372"
            transform="matrix(4.37114e-08 1 1 -4.37114e-08 135.086 7.75977)"
            fill="#82D0F3"
          />
          <path
            d="M136.36 7.75977C135.656 7.75977 135.086 8.33003 135.086 9.03348L135.086 20.3696L166.929 34.2531L166.929 9.03348C166.929 8.33003 166.359 7.75976 165.655 7.75976L136.36 7.75977Z"
            fill="#399ED5"
          />
          <circle
            cx="2.29269"
            cy="2.29269"
            r="2.29269"
            transform="matrix(-1 0 0 1 153.172 45.7168)"
            fill="#FAFAFA"
          />
        </g>
        <g filter="url(#filter2_d_12793_7623)">
          <path
            d="M150.799 372.076V362.627H157.548V372.076H150.799Z"
            fill="#F9C18C"
          />
          <path
            d="M155.861 215.496V213.809V213.472L152.487 211.109V213.134L155.861 215.496Z"
            fill="#060000"
          />
          <path
            d="M162.273 203.348C162.813 201.998 162.498 199.411 162.273 198.286L154.849 193.899L146.075 199.636V218.196L155.523 218.871V215.159C154.174 214.619 152.036 211.785 151.137 210.435C155.186 214.147 157.886 213.809 159.573 213.809C160.923 213.809 161.935 209.985 162.273 208.073L164.599 206.909C164.828 206.795 164.973 206.556 164.87 206.322C164.476 205.425 163.044 204.023 162.273 203.348Z"
            fill="#F9C18C"
            stroke="#F9C18C"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M144.829 213.531C147.528 213.531 149.778 210.606 150.566 209.144C150.116 208.806 149.013 207.794 148.203 206.444C147.191 204.757 148.878 201.045 150.228 201.382C151.308 201.652 151.803 203.519 151.915 204.419C152.995 203.879 153.49 201.045 153.603 199.695C154.413 199.425 155.515 197.333 155.965 196.32C160.554 199.83 163.501 198.907 164.401 198.008C160.689 194.97 163.051 193.621 158.327 189.909C154.548 186.939 151.128 189.346 149.891 190.921C148.203 189.909 144.289 189.166 142.13 194.296C139.97 199.425 142.804 204.757 144.491 206.781C143.681 208.671 144.379 212.068 144.829 213.531Z"
            fill="#142B49"
            stroke="#142B49"
            stroke-width="0.674912"
            stroke-linejoin="round"
          />
          <path
            d="M150.461 372.076V368.701H150.124C149.006 368.701 148.099 369.608 148.099 370.726V379.5H171.384C170.844 373.561 163.96 371.176 160.585 370.726C160.922 369.826 160.922 368.026 158.223 368.026C155.523 368.026 154.848 370.726 154.848 372.076H150.461Z"
            fill="#6F91AB"
            stroke="#6F91AB"
            stroke-width="0.674912"
          />
          <path
            d="M168.347 372.75C166.772 372.975 163.42 373.83 162.61 375.45M162.947 372.75C164.297 372.863 167.267 373.56 168.347 375.45M159.573 372.413C159.91 371.963 160.99 370.996 162.61 370.726M159.573 370.726C160.135 370.726 161.597 370.996 162.947 372.075"
            stroke="black"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M161.597 316.734C164.027 310.794 165.309 288.612 165.647 278.264C161.058 273.674 150.011 277.701 145.061 280.288C144.521 288.657 147.986 306.948 149.786 315.046C144.927 327.735 147.762 352.054 149.786 362.628H158.223C158.223 336.441 160.472 321.121 161.597 316.734Z"
            fill="#142B49"
            stroke="#142B49"
            stroke-width="0.674912"
          />
          <path
            d="M151.555 280.714L156.734 279.733C160.04 284.35 160.823 286.996 160.698 288.35C160.629 289.092 159.761 288.957 159.233 288.431C158.864 288.064 158.464 287.713 158.206 287.501C158.835 289.575 158.9 291.924 158.812 293.527C158.771 294.278 158.074 294.788 157.363 294.541C155.705 293.965 153.546 292.704 152.737 290.429C151.682 287.463 151.509 282.717 151.555 280.714Z"
            fill="#F9C18C"
            stroke="#F9C18C"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M140 229.67V275.04C140 276.627 140.811 278.105 142.15 278.957C143.181 279.613 144.331 280.072 145.542 280.229C154.21 281.355 162.222 279.696 166.531 278.264C167.632 277.899 168.286 276.814 168.201 275.658C167.505 266.146 166.407 248.093 166.659 238.781C166.929 228.792 159.797 221.346 156.198 218.871L145.737 218.196C141.417 219.546 140.112 226.408 140 229.67Z"
            fill="#00BBB1"
            stroke="#00BBB1"
            stroke-width="0.674912"
          />
          <path
            d="M143.48 251.267C143.106 244.357 143.788 236.833 144.542 231.4C144.987 228.188 148.074 226.134 151.253 226.77C153.84 227.287 155.768 229.463 155.971 232.094L156.303 236.419C156.573 239.658 154.391 247.667 153.266 251.267C155.966 264.225 157.766 276.463 158.328 280.963H151.241C145.572 272.054 143.705 257.453 143.48 251.267Z"
            fill="#00968E"
            stroke="#00968E"
            stroke-width="0.674912"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M143 218.107C143 216.667 144.167 215.5 145.607 215.5H157.5L160.5 222L145.384 220.704C144.036 220.589 143 219.46 143 218.107Z"
            fill="#00BBB1"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_12793_7623"
            x="148"
            y="216.5"
            width="98"
            height="81"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12793_7623"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12793_7623"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_12793_7623"
            x="107.391"
            y="0.5"
            width="86.9727"
            height="190.364"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12793_7623"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12793_7623"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_12793_7623"
            x="135.663"
            y="188.162"
            width="40.0903"
            height="199.675"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_12793_7623"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_12793_7623"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    main_heading: "Phase 3: Forward Reach",
    text1: "Left arm should be",
    text2: "visible to the camera.",
  },
};

const mCTSIBAssesmentData = {
  "1": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="280"
        height="251"
        viewBox="0 0 280 251"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 165.835C65.6359 278.855 214.713 278.855 280 165.835C214.713 53.1631 65.6359 52.8143 0 165.835ZM140 215.717C112.419 215.717 90.0748 193.392 90.0748 165.835C90.0748 138.277 112.419 115.952 140 115.952C167.581 115.952 189.925 138.277 189.925 165.835C189.925 193.392 167.581 215.717 140 215.717Z"
          fill="#802392"
        />
        <path
          d="M252.861 93.0596C254.763 93.0596 256.666 92.4255 257.934 91.1574L276.639 76.5738C280.443 73.7205 281.077 68.3309 278.224 64.5265C275.371 60.7221 269.981 60.088 266.177 62.9413L247.472 78.159C243.667 81.0123 243.033 86.4019 245.887 90.2063C247.789 92.1085 250.325 93.0596 252.861 93.0596Z"
          fill="#802392"
        />
        <path
          d="M212.915 57.8701C215.769 57.8701 218.622 56.285 220.207 53.7487L232.254 33.1415C234.791 29.02 233.205 23.9475 229.401 21.4112C225.28 18.8749 220.207 20.4601 217.671 24.2645L205.624 44.8717C203.087 48.9932 204.672 54.0657 208.477 56.602C210.062 57.5531 211.647 57.8701 212.915 57.8701Z"
          fill="#802392"
        />
        <path
          d="M165.365 40.4326C169.486 40.4326 172.974 37.5793 173.608 33.4579L177.729 9.99737C178.68 5.24186 175.51 1.12043 170.754 0.169327C166.316 -0.781776 161.877 2.38856 161.243 6.82703L157.122 30.2875C156.171 35.043 159.341 39.1645 164.097 40.1156C164.414 40.4326 164.731 40.4326 165.365 40.4326Z"
          fill="#802392"
        />
        <path
          d="M114.952 40.4326C115.586 40.4326 115.903 40.4326 116.537 40.4326C121.293 39.4815 124.146 35.043 123.512 30.6046L119.39 7.14406C118.439 2.38855 114.001 -0.464745 109.562 0.169323C104.807 1.12043 101.954 5.24186 102.588 9.99737L106.709 33.4579C107.343 37.5793 110.831 40.4326 114.952 40.4326Z"
          fill="#802392"
        />
        <path
          d="M67.4033 57.8701C68.9884 57.8701 70.2566 57.5531 71.8418 56.602C75.9632 54.0657 77.2313 48.9932 74.6951 44.8717L62.3307 24.5816C59.7945 20.4601 54.7219 19.192 50.6005 21.7282C46.479 24.2645 45.2109 29.3371 47.7472 33.4585L59.7945 54.0657C61.6967 56.602 64.2329 57.8701 67.4033 57.8701Z"
          fill="#802392"
        />
        <path
          d="M27.453 93.0596C29.9892 93.0596 32.5255 91.7914 34.1107 89.8892C36.964 86.0848 36.3299 81.0123 32.5255 77.8419L13.8205 63.2584C10.0161 60.4051 4.62653 61.0392 1.77323 64.8436C-1.08008 68.648 -0.446011 73.7205 3.3584 76.8908L22.0634 91.4744C23.6486 92.7425 25.5508 93.0596 27.453 93.0596Z"
          fill="#802392"
        />
      </svg>
    ),
    main_heading: "Phase 1",
    text1: "Standing on Floor",
    text2: "with Eyes Open",
  },
  "2": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="280"
        height="172"
        viewBox="0 0 280 172"
        fill="none"
      >
        <path
          d="M252.861 78.6982C254.763 78.6982 256.666 79.3323 257.934 80.6004L276.639 95.184C280.443 98.0373 281.077 103.427 278.224 107.231C275.371 111.036 269.981 111.67 266.177 108.816L247.472 93.5988C243.667 90.7455 243.033 85.3559 245.887 81.5515C247.789 79.6493 250.325 78.6982 252.861 78.6982Z"
          fill="#802392"
        />
        <path
          d="M212.915 113.888C215.769 113.888 218.622 115.473 220.207 118.009L232.254 138.616C234.791 142.738 233.205 147.81 229.401 150.347C225.28 152.883 220.207 151.298 217.671 147.493L205.624 126.886C203.087 122.765 204.672 117.692 208.477 115.156C210.062 114.205 211.647 113.888 212.915 113.888Z"
          fill="#802392"
        />
        <path
          d="M165.365 131.324C169.486 131.324 172.974 134.178 173.608 138.299L177.729 161.759C178.68 166.515 175.51 170.636 170.754 171.588C166.316 172.539 161.877 169.368 161.243 164.93L157.122 141.469C156.171 136.714 159.341 132.592 164.097 131.641C164.414 131.324 164.731 131.324 165.365 131.324Z"
          fill="#802392"
        />
        <path
          d="M114.952 131.324C115.586 131.324 115.903 131.324 116.537 131.324C121.293 132.275 124.146 136.714 123.512 141.152L119.39 164.613C118.439 169.368 114.001 172.222 109.562 171.588C104.807 170.636 101.954 166.515 102.588 161.759L106.709 138.299C107.343 134.178 110.831 131.324 114.952 131.324Z"
          fill="#802392"
        />
        <path
          d="M67.4033 113.888C68.9884 113.888 70.2566 114.205 71.8418 115.156C75.9632 117.692 77.2313 122.765 74.6951 126.886L62.3307 147.176C59.7945 151.298 54.7219 152.566 50.6005 150.03C46.479 147.493 45.2109 142.421 47.7472 138.299L59.7945 117.692C61.6967 115.156 64.2329 113.888 67.4033 113.888Z"
          fill="#802392"
        />
        <path
          d="M27.453 78.6982C29.9892 78.6982 32.5255 79.9664 34.1107 81.8686C36.964 85.673 36.3299 90.7455 32.5255 93.9159L13.8205 108.499C10.0161 111.353 4.62653 110.719 1.77323 106.914C-1.08008 103.11 -0.446011 98.0373 3.3584 94.867L22.0634 80.2834C23.6486 79.0153 25.5508 78.6982 27.453 78.6982Z"
          fill="#802392"
        />
        <path
          d="M140 78.4918C83.4218 78.4918 40.059 37.1803 19.41 0L0 10.3279C30.5605 65.2721 85.0737 100.8 140 100.8C195.339 100.8 249.852 65.6852 280 10.3279L260.59 0C239.941 37.1803 196.991 78.4918 140 78.4918Z"
          fill="#802392"
        />
      </svg>
    ),
    main_heading: "Phase 2",
    text1: "Standing on Floor",
    text2: "with Eyes Closed",
  },
  "3": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="280"
        height="251"
        viewBox="0 0 280 251"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 165.835C65.6359 278.855 214.713 278.855 280 165.835C214.713 53.1631 65.6359 52.8143 0 165.835ZM140 215.717C112.419 215.717 90.0748 193.392 90.0748 165.835C90.0748 138.277 112.419 115.952 140 115.952C167.581 115.952 189.925 138.277 189.925 165.835C189.925 193.392 167.581 215.717 140 215.717Z"
          fill="#802392"
        />
        <path
          d="M252.861 93.0596C254.763 93.0596 256.666 92.4255 257.934 91.1574L276.639 76.5738C280.443 73.7205 281.077 68.3309 278.224 64.5265C275.371 60.7221 269.981 60.088 266.177 62.9413L247.472 78.159C243.667 81.0123 243.033 86.4019 245.887 90.2063C247.789 92.1085 250.325 93.0596 252.861 93.0596Z"
          fill="#802392"
        />
        <path
          d="M212.915 57.8701C215.769 57.8701 218.622 56.285 220.207 53.7487L232.254 33.1415C234.791 29.02 233.205 23.9475 229.401 21.4112C225.28 18.8749 220.207 20.4601 217.671 24.2645L205.624 44.8717C203.087 48.9932 204.672 54.0657 208.477 56.602C210.062 57.5531 211.647 57.8701 212.915 57.8701Z"
          fill="#802392"
        />
        <path
          d="M165.365 40.4326C169.486 40.4326 172.974 37.5793 173.608 33.4579L177.729 9.99737C178.68 5.24186 175.51 1.12043 170.754 0.169327C166.316 -0.781776 161.877 2.38856 161.243 6.82703L157.122 30.2875C156.171 35.043 159.341 39.1645 164.097 40.1156C164.414 40.4326 164.731 40.4326 165.365 40.4326Z"
          fill="#802392"
        />
        <path
          d="M114.952 40.4326C115.586 40.4326 115.903 40.4326 116.537 40.4326C121.293 39.4815 124.146 35.043 123.512 30.6046L119.39 7.14406C118.439 2.38855 114.001 -0.464745 109.562 0.169323C104.807 1.12043 101.954 5.24186 102.588 9.99737L106.709 33.4579C107.343 37.5793 110.831 40.4326 114.952 40.4326Z"
          fill="#802392"
        />
        <path
          d="M67.4033 57.8701C68.9884 57.8701 70.2566 57.5531 71.8418 56.602C75.9632 54.0657 77.2313 48.9932 74.6951 44.8717L62.3307 24.5816C59.7945 20.4601 54.7219 19.192 50.6005 21.7282C46.479 24.2645 45.2109 29.3371 47.7472 33.4585L59.7945 54.0657C61.6967 56.602 64.2329 57.8701 67.4033 57.8701Z"
          fill="#802392"
        />
        <path
          d="M27.453 93.0596C29.9892 93.0596 32.5255 91.7914 34.1107 89.8892C36.964 86.0848 36.3299 81.0123 32.5255 77.8419L13.8205 63.2584C10.0161 60.4051 4.62653 61.0392 1.77323 64.8436C-1.08008 68.648 -0.446011 73.7205 3.3584 76.8908L22.0634 91.4744C23.6486 92.7425 25.5508 93.0596 27.453 93.0596Z"
          fill="#802392"
        />
      </svg>
    ),
    main_heading: "Phase 3",
    text1: "Standing on Foam",
    text2: "with Eyes Open",
  },
  "4": {
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="280"
        height="172"
        viewBox="0 0 280 172"
        fill="none"
      >
        <path
          d="M252.861 78.6982C254.763 78.6982 256.666 79.3323 257.934 80.6004L276.639 95.184C280.443 98.0373 281.077 103.427 278.224 107.231C275.371 111.036 269.981 111.67 266.177 108.816L247.472 93.5988C243.667 90.7455 243.033 85.3559 245.887 81.5515C247.789 79.6493 250.325 78.6982 252.861 78.6982Z"
          fill="#802392"
        />
        <path
          d="M212.915 113.888C215.769 113.888 218.622 115.473 220.207 118.009L232.254 138.616C234.791 142.738 233.205 147.81 229.401 150.347C225.28 152.883 220.207 151.298 217.671 147.493L205.624 126.886C203.087 122.765 204.672 117.692 208.477 115.156C210.062 114.205 211.647 113.888 212.915 113.888Z"
          fill="#802392"
        />
        <path
          d="M165.365 131.324C169.486 131.324 172.974 134.178 173.608 138.299L177.729 161.759C178.68 166.515 175.51 170.636 170.754 171.588C166.316 172.539 161.877 169.368 161.243 164.93L157.122 141.469C156.171 136.714 159.341 132.592 164.097 131.641C164.414 131.324 164.731 131.324 165.365 131.324Z"
          fill="#802392"
        />
        <path
          d="M114.952 131.324C115.586 131.324 115.903 131.324 116.537 131.324C121.293 132.275 124.146 136.714 123.512 141.152L119.39 164.613C118.439 169.368 114.001 172.222 109.562 171.588C104.807 170.636 101.954 166.515 102.588 161.759L106.709 138.299C107.343 134.178 110.831 131.324 114.952 131.324Z"
          fill="#802392"
        />
        <path
          d="M67.4033 113.888C68.9884 113.888 70.2566 114.205 71.8418 115.156C75.9632 117.692 77.2313 122.765 74.6951 126.886L62.3307 147.176C59.7945 151.298 54.7219 152.566 50.6005 150.03C46.479 147.493 45.2109 142.421 47.7472 138.299L59.7945 117.692C61.6967 115.156 64.2329 113.888 67.4033 113.888Z"
          fill="#802392"
        />
        <path
          d="M27.453 78.6982C29.9892 78.6982 32.5255 79.9664 34.1107 81.8686C36.964 85.673 36.3299 90.7455 32.5255 93.9159L13.8205 108.499C10.0161 111.353 4.62653 110.719 1.77323 106.914C-1.08008 103.11 -0.446011 98.0373 3.3584 94.867L22.0634 80.2834C23.6486 79.0153 25.5508 78.6982 27.453 78.6982Z"
          fill="#802392"
        />
        <path
          d="M140 78.4918C83.4218 78.4918 40.059 37.1803 19.41 0L0 10.3279C30.5605 65.2721 85.0737 100.8 140 100.8C195.339 100.8 249.852 65.6852 280 10.3279L260.59 0C239.941 37.1803 196.991 78.4918 140 78.4918Z"
          fill="#802392"
        />
      </svg>
    ),
    main_heading: "Phase 4",
    text1: "Standing on Foam",
    text2: "with Eyes Closed",
  },
};

const topBar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="655"
    height="49"
    viewBox="0 0 655 49"
    fill="none"
  >
    <rect x="0.945801" y="14.5" width="192" height="20" rx="8" fill="#802392" />
    <rect x="200.946" y="14.5" width="192" height="20" rx="8" fill="#D9D9D9" />
    <rect x="400.946" y="14.5" width="192" height="20" rx="8" fill="#D9D9D9" />
    <path
      d="M608.089 38V17.408L603.229 20.396V14.996L608.089 12.08H613.093V38H608.089ZM626.489 12.08H631.385L624.473 38H619.577L626.489 12.08ZM643.633 38.468C642.337 38.468 641.101 38.21 639.925 37.694C638.749 37.166 637.723 36.428 636.847 35.48C635.983 34.532 635.365 33.416 634.993 32.132L639.745 30.872C639.997 31.82 640.489 32.558 641.221 33.086C641.965 33.602 642.769 33.86 643.633 33.86C644.377 33.86 645.055 33.68 645.667 33.32C646.291 32.96 646.783 32.474 647.143 31.862C647.515 31.25 647.701 30.572 647.701 29.828C647.701 28.712 647.317 27.758 646.549 26.966C645.793 26.162 644.821 25.76 643.633 25.76C643.273 25.76 642.925 25.814 642.589 25.922C642.253 26.018 641.929 26.156 641.617 26.336L639.421 22.484L647.665 15.644L648.025 16.688H636.001V12.08H652.201V16.688L645.793 22.88L645.757 21.512C647.245 21.74 648.499 22.262 649.519 23.078C650.551 23.882 651.331 24.878 651.859 26.066C652.399 27.242 652.669 28.496 652.669 29.828C652.669 31.46 652.255 32.93 651.427 34.238C650.599 35.534 649.501 36.566 648.133 37.334C646.765 38.09 645.265 38.468 643.633 38.468Z"
      fill="#31344E"
    />
  </svg>
);

const lowerArrows = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="676"
    height="96"
    viewBox="0 0 676 96"
    fill="none"
  >
    <path
      d="M45.9004 75.4973C47.3254 76.6823 49.3204 76.9523 51.0154 76.1573C52.7104 75.3623 53.7754 73.6673 53.7754 71.8073V23.8073C53.7754 21.9473 52.6954 20.2523 51.0154 19.4573C49.3354 18.6623 47.3404 18.9173 45.9004 20.1173L17.1004 44.1173L15.3754 45.5573V23.8073C15.3754 21.1523 13.2304 19.0073 10.5754 19.0073C7.92039 19.0073 5.77539 21.1523 5.77539 23.8073V71.8073C5.77539 74.4623 7.92039 76.6073 10.5754 76.6073C13.2304 76.6073 15.3754 74.4623 15.3754 71.8073V50.0573L17.1004 51.4973L45.9004 75.4973Z"
      fill="#D1D1D1"
    />
    <path
      d="M629.65 75.4973C628.225 76.6823 626.23 76.9523 624.535 76.1573C622.84 75.3623 621.775 73.6673 621.775 71.8073V23.8073C621.775 21.9473 622.855 20.2523 624.535 19.4573C626.215 18.6623 628.21 18.9173 629.65 20.1173L658.45 44.1173L660.175 45.5573V23.8073C660.175 21.1523 662.32 19.0073 664.975 19.0073C667.63 19.0073 669.775 21.1523 669.775 23.8073V71.8073C669.775 74.4623 667.63 76.6073 664.975 76.6073C662.32 76.6073 660.175 74.4623 660.175 71.8073V50.0573L658.45 51.4973L629.65 75.4973Z"
      fill="#802392"
    />
  </svg>
);

const AROMInitialModal: React.FC<Props> = ({ phaseNo, subAssessment }) => {
  return (
    <>
      <div
        className="generic-assesment-text-modal"
        style={{
          textAlign: "center",
        }}
      >
        <div className="align-center" style={sessionStorage.getItem("selectedAssesment") === "1" ? { display: "flex", flexDirection: "column", alignItems: "center", gap: "24px", padding: "32px" } : { height: "800px" }}>
          <div
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: sessionStorage.getItem("selectedAssesment") === "1" ? "0px" : "20px",
            }}
          >
            {sessionStorage.getItem("selectedAssesment") === "55"
              ? assesmentData[phaseNo as "1" | "2" | "3"].main_heading
              : sessionStorage.getItem("selectedAssesment") === "1"
              ? mCTSIBAssesmentData[phaseNo as "1" | "2" | "3" | "4"]
                  .main_heading
              : FRAssesmentData[phaseNo as "1" | "2" | "3"].main_heading}
          </div>
          {sessionStorage.getItem("selectedAssesment") !== "1" && topBar}
          {sessionStorage.getItem("selectedAssesment") === "55"
            ? assesmentData[phaseNo as "1" | "2" | "3"].img
            : sessionStorage.getItem("selectedAssesment") === "1"
            ? mCTSIBAssesmentData[phaseNo as "1" | "2" | "3" | "4"].img
            : FRAssesmentData[phaseNo as "1" | "2" | "3"].img}
          <div
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginTop: sessionStorage.getItem("selectedAssesment") === "1" ? "0px" : "20px",
            }}
          >
            <div>
              {sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[phaseNo as "1" | "2" | "3"].text1
                : sessionStorage.getItem("selectedAssesment") === "1"
                ? mCTSIBAssesmentData[phaseNo as "1" | "2" | "3" | "4"].text1
                : FRAssesmentData[phaseNo as "1" | "2" | "3"].text1}
            </div>
            <div>
              {sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[phaseNo as "1" | "2" | "3"].text2
                : sessionStorage.getItem("selectedAssesment") === "1"
                ? mCTSIBAssesmentData[phaseNo as "1" | "2" | "3" | "4"].text2
                : FRAssesmentData[phaseNo as "1" | "2" | "3"].text2}
            </div>
          </div>
          {sessionStorage.getItem("selectedAssesment") !== "1" && lowerArrows}
        </div>
      </div>
    </>
  );
};

export default AROMInitialModal;
